import React, { FunctionComponent } from "react"
import { RowClassParams, RowClickedEvent } from "ag-grid-community"
import { Grid } from "../../shared/Grid"
import { NotificationRow, notificationsTableCols } from "./notifications-table-helper"
import { SortModel } from "../../../data/services/grid-storage-service"
import { isCloudApi } from "src/data/api"

interface Props {
    rows: NotificationRow[]
    loading: boolean
    selected:  NotificationRow[ ]
    onSelectionChange: (selected: NotificationRow[]) => void
    markUnread: (notification: NotificationRow, unread: boolean) => void
}

export const NotificationsTable: FunctionComponent<Props> = props => {

    const getRowStyle = (params: RowClassParams) => {
        const notification: NotificationRow = params.data
        const styles: any = {}
        if (notification.unread) {
            styles.backgroundColor = "white"
            styles.fontWeight = "400"
        } else {
            styles.backgroundColor = "#f2f6fc"
            styles.fontWeight = "200"
        }
        return styles
    }

    const onRowChecked = (event: RowClickedEvent) => {
        const notification = event.node.data
        props.markUnread(notification, false)
    }

    let spanInner = "There are no notifications."
    if (!isCloudApi()) {
        spanInner += '\nClick "View Notification Log" above to download archived\nnotifications on the SMRTLink file system'
    }
    const noNotificationsMarkup =
        `<span class="ag-overlay-loading-center" style="pointer-events: auto;">${spanInner}</span>`

    const sortModel: SortModel = [{
        colId: "createdAt",
        sort: "desc"
    }]

    return (
        <div
            className="ag-theme-alpine notifications-table"
            style={{ height: "25rem", minHeight: "200px", width: "100%" }}
        >
            <Grid
                selectionMode = "Multiple"
                suppressSelectionHighlighting
                disableSearch
                headerData={notificationsTableCols}
                tableId={"alarms-modal"}
                sortModel={sortModel}
                data={props.rows}
                selected = {props.selected}
                onSelectionChange={ (selected) => props.onSelectionChange(selected as NotificationRow[])}
                idField={"id"}
                loading={false}
                rowBuffer={0}
                getRowStyle = {getRowStyle}
                suppressCellFocus
                hideScrollPositionLabel
                overlayNoRowsTemplate={noNotificationsMarkup}
                onRowClicked={ onRowChecked }
                rowClickExcludedColumns={["isChecked"]}
                autoResizeColumns
            />

        </div>
    )
}
